<div 
  class="menu" 
  [ngClass]="{
    'collapsed': isCollapsed,
    'light-mode': lightMode
    }">

  <div 
    class="heading-container" 
    [ngClass]="{ 
    'collapsed': isCollapsed,
    'light-mode': lightMode }" >
    <mat-icon 
      class="double-arrow-icon" 
      [ngClass]="{ 
        'collapsed': isCollapsed, 
        'light-mode': lightMode }" 
      (click)="toggleIsCollapsed()" 
      lines="none" 
      button="true" >
      {{isCollapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left'}}
    </mat-icon>
  </div>
  <hr class="custom-line">
  <div class="menuItems" 
  [ngClass]="{
    'collapsed': isCollapsed, 
    'light-mode': lightMode}">
    @for (mainMenuItem of menuItems['menuItems']; track mainMenuItem; let i = $index) {
    <div class="header-panel-container">
      @if ( mainMenuItem['menuItems'] != null && mainMenuItem['menuItems'].length == 0 && !mainMenuItem['disabled'] ) {
      <mat-expansion-panel 
        [ngClass]="{ 'light-mode': lightMode}"
        hideToggle #panel [expanded]="false">
        <mat-expansion-panel-header 
          class="side-nav-headers"
          [ngClass]="{
            'collapsed': isCollapsed, 
            'light-mode': lightMode,
            'active': mainMenuItem['active']}"
          (click)="navigateTo(mainMenuItem['menuItems'] && mainMenuItem['menuItems'].length == 0 ? '/' + mainMenuItem.link : null, mainMenuItem); expandPanel($event, i); toggleActive(i, false, $event)"
        >
          <mat-panel-title class="side-nav-title" [ngClass]="{ 'light-mode': lightMode }">
            @if (mainMenuItem.customIcon != null && mainMenuItem.customIcon) {
            <mat-icon [ngClass]="{ 
              'collapsed': isCollapsed, 
              'light-mode': lightMode }"  >
              <img 
                class="huge-icon" 
                [ngClass]="{ 'collapsed': isCollapsed, 'light-mode': lightMode }" 
                [src]="mainMenuItem['active'] && mainMenuItem.activeIcon ? mainMenuItem.activeIcon : mainMenuItem.icon" 
              />
            </mat-icon>
            } @if (mainMenuItem.customIcon == null || !mainMenuItem.customIcon) {
            <mat-icon>
              {{ mainMenuItem.icon + '-outline' }}
            </mat-icon>
            }
            @if(!isCollapsed){
              <mat-label>{{ mainMenuItem['title'] }}</mat-label>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      }
      <!-- </div> -->

      <!-- Multiple menu items -->
      <mat-accordion>
        @if (mainMenuItem['menuItems'] != null && mainMenuItem['menuItems'].length > 0) {
        <mat-expansion-panel 
          class="dropdown" 
          [ngClass]="{ 'light-mode': lightMode}"
          [hideToggle]="isCollapsed" 
          [disabled]="isCollapsed" 
          [(expanded)]="mainMenuItem['Open']"  
          #panel>
          <mat-expansion-panel-header 
            class="side-nav-headers" 
            [ngClass]="{
                'collapsed': isCollapsed, 
                'light-mode': lightMode,
                'active': updateMainMenuItemState(mainMenuItem),
                'open': mainMenuItem['subOpen'] }"
            (click)="toggleActive(i, isCollapsed, $event)">
            <mat-panel-title 
              class="side-nav-title" [ngClass]="{ 'light-mode': lightMode }">
              @if (mainMenuItem.customIcon != null && mainMenuItem.customIcon) {
              <mat-icon 
                [ngClass]="{ 
                  'collapsed': isCollapsed, 
                  'open': mainMenuItem['subOpen'],
                  'light-mode': lightMode }"  >
                <img 
                  class="huge-icon" 
                  [ngClass]="{ 
                    'collapsed': isCollapsed, 
                    'open': mainMenuItem['subOpen'], 
                    'light-mode': lightMode}" 
                  [src]="(updateMainMenuItemState(mainMenuItem) && mainMenuItem.activeIcon) || (mainMenuItem['subOpen'] && isCollapsed) ? mainMenuItem.activeIcon : mainMenuItem.icon" />
              </mat-icon>
              } @if (mainMenuItem.customIcon == null || !mainMenuItem.customIcon) {
              <mat-icon>
                <img 
                  class="huge-icon" 
                  [src]="mainMenuItem.icon + '-outline'" />
              </mat-icon>
              }
              @if (!isCollapsed) {
                <mat-label>{{ mainMenuItem['title'] }}</mat-label>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="dropdown-menu" [ngClass]="{'light-mode': lightMode }">
            @for (subMenuItem of mainMenuItem['menuItems']; track subMenuItem) {
              <mat-list-item 
                class="sub-menu" 
                button="true" 
                lines="none" 
                [ngClass]="{'light-mode': lightMode, 'active': subMenuItem['active']}" 
                (click)="navigateTo(subMenuItem['link'], mainMenuItem, subMenuItem, subMenuItem['queryParams'])">

                <div 
                  class="sub-list-items"
                  [ngClass]="{'light-mode': lightMode, 'active': subMenuItem['active']}" >
                  @if (subMenuItem.customIcon != null && subMenuItem.customIcon) {
                  <mat-icon [ngClass]="{'light-mode': lightMode, 'collapsed': isCollapsed }"  >
                    <img 
                      class="huge-icon" 
                      [ngClass]="{'light-mode': lightMode, 'collapsed': isCollapsed }"  
                      [src]="subMenuItem['active'] && subMenuItem.activeIcon ? subMenuItem.activeIcon : subMenuItem.icon"/>
                  </mat-icon>
                  } @if (subMenuItem.customIcon == null || !subMenuItem.customIcon) {
                  <mat-icon>{{ subMenuItem.icon }}</mat-icon>
                  }
                  <mat-label>{{ subMenuItem['title'] }}</mat-label>
                </div>
              </mat-list-item>
            }
          </div>
        </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
    }     
    <!-- @if (appVersion != null) {
    <div class="versioning">
      <p>{{ appVersion }}</p>
    </div>
    } -->
  </div>
  <div
      class="huge-logo-icon"
      style.background-image="url({{path + 'HugeSideNav.png'}})"
    ></div>
</div>
